module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_off_2.758cd8ef.svg";